export function setRoles(state, roles) {
    state.roles = roles
}

export function setSelectedRoleId(state, roleId) {
    state.selectedRoleId = roleId
}

export function setPermissions(state, permissions) {
    state.permissions = permissions
}

// Marca/desmarca un indicador puntual por `name` (usado por el v-model de cada checkbox).
export function setPermissionCheck(state, { name, check }) {
    const permission = state.permissions.find(p => p.name === name)
    if (permission) {
        permission.check = check
    }
}

export function setLoading(state, loading) {
    state.loading = loading
}

export function setSaving(state, saving) {
    state.saving = saving
}
